module.exports = __webpack_public_path__ + "img/smart.1ad77fab.png";